import { Link } from "react-router-dom";
import { Settings } from "lucide-react";
import { useSilver, scrollToId } from "@/context/SilverContext";
import { CONTACT } from "@/data/content";

const ext = (path = "") => `${CONTACT.site}${path}`;

export default function Footer() {
  const { setHowOpen } = useSilver();
  const cols = [
    { title: "Property Marketing", links: [["Property photography", ext()], ["CRM integrations", ext()], ["Case studies", ext()]] },
    { title: "Design & Print", links: [["Design and print", ext()], ["Talk to Print", CONTACT.phoneHref]] },
  ];
  return (
    <footer className="relative border-t border-white/10 bg-[#0C2010]/80" data-testid="site-footer">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 py-16 sm:px-8 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <img src="/brand/nichecom-logo-dark.png" alt="NicheCom — visual marketing redefined" className="h-12 w-auto" />
          <p className="mt-6 max-w-sm text-[14px] leading-relaxed text-white/55">
            NicheCom is the UK's leading provider of property marketing services, bringing homes to life with photography, floorplans, 3D walkthroughs, video, aerial and print.
          </p>
        </div>
        {cols.map((c) => (
          <div key={c.title} className="lg:col-span-2">
            <p className="eyebrow-muted">{c.title}</p>
            <ul className="mt-5 space-y-3 text-[14px]">
              {c.links.map(([label, href]) => <li key={label}><a href={href} className="text-white/70 transition-colors hover:text-white">{label}</a></li>)}
            </ul>
          </div>
        ))}
        <div className="lg:col-span-2">
          <p className="eyebrow-muted">Audience intelligence</p>
          <ul className="mt-5 space-y-3 text-[14px]">
            <li><button type="button" onClick={() => scrollToId("how")} className="text-white/70 hover:text-white">How it works</button></li>
            <li><button type="button" onClick={() => scrollToId("audience")} className="text-white/70 hover:text-white">The audience</button></li>
            <li><button type="button" onClick={() => scrollToId("build")} className="text-white/70 hover:text-white">Build an audience</button></li>
            <li><button type="button" onClick={() => setHowOpen(true)} className="text-white/70 hover:text-white" data-testid="footer-how-calculated-btn">How it's calculated</button></li>
          </ul>
        </div>
        <div className="lg:col-span-2">
          <p className="eyebrow-muted">Contact</p>
          <address className="mt-5 space-y-1 text-[14px] not-italic text-white/70">
            {CONTACT.address.map((l) => <p key={l}>{l}</p>)}
            <p className="pt-3"><a href={CONTACT.phoneHref} className="hover:text-white">{CONTACT.phone}</a></p>
            <p><a href={`mailto:${CONTACT.email}`} className="hover:text-white">{CONTACT.email}</a></p>
          </address>
        </div>
      </div>
      <div className="border-t border-white/[0.07]">
        <div className="mx-auto flex max-w-7xl flex-col gap-3 px-5 pb-24 pt-6 text-[12px] text-white/40 sm:flex-row sm:items-center sm:justify-between sm:px-8">
          <p>© NicheCom 2026. Audience intelligence and direct mail from NicheCom Print.</p>
          <div className="flex items-center gap-5">
            <a href={ext()} className="hover:text-white">Privacy Policy</a>
            <a href={ext()} className="hover:text-white">GDPR policy</a>
            <a href={ext()} className="hover:text-white">Terms of use</a>
            <button type="button" onClick={() => window.dispatchEvent(new Event("nc-consent-reset"))} className="hover:text-white" data-testid="footer-analytics-prefs">Analytics preferences</button>
            <Link to="/admin" className="hover:text-white" data-testid="footer-admin-link">Team login</Link>
            <Link to="/insights" aria-label="Settings" className="ml-2 text-white/20 transition-colors hover:text-white/70" data-testid="footer-insights-cog"><Settings className="h-3.5 w-3.5" /></Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
